import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { FilterProvider } from "./contexts/FilterContext";
import useIsMobile from "./hooks/useIsMobile";
import Main from "./components/root/Main";
import { ReportProvider } from "./contexts/ReportContext";

function App() {
	const isMobile = useIsMobile();
	return (
		<BrowserRouter>
			<Routes>
				<Route
					path="/*"
					element={
						<FilterProvider>
							<ReportProvider>
								<Main isMobile={isMobile} />
							</ReportProvider>
						</FilterProvider>
					}
				/>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
